import { render } from "./NewOrder.vue?vue&type=template&id=0526d22f"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"

import "./NewOrder.vue?vue&type=style&index=0&id=0526d22f&lang=scss"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__